import { Theme, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../constants';
import { getData } from '../../utils/api';

const styles = {
  width: 'max-content',
  px: {
    xs: 1.5,
    md: 2,
  },
  py: {
    xs: 1,
    md: 1.75,
  },
  border: (theme: Theme) => `1px solid ${theme.palette.selected.blue}`,
  backgroundColor: 'background.lightBlue',
  borderRadius: 1,
  display: 'flex',
  alignItems: 'center',
  typography: {
    xs: 'h6',
    md: 'body1',
  },
};

const DailyReportsTotalUsers = () => {
  const { data: totalUsers } = useQuery<{ count: number }>({
    queryKey: [QUERY_KEYS.totalUserCount],
    queryFn: () => getData('customer/active/count', {}, 'crm'),
  });

  return <Typography sx={styles}>Total Users: {totalUsers?.count}</Typography>;
};

export default DailyReportsTotalUsers;
